import React from 'react'
import styled from 'styled-components'
import { SlBadge, SlTooltip } from '@shoelace-style/shoelace/dist/react'
import { HelpIcon } from '@nominex/dex-uikit'
import { useTranslation } from 'contexts/Localization'
import { BaseStyledBadge } from './styles'

// TODO: gradient should be moved to tailwind config
const StyledSlBadge = styled(SlBadge)`
  ::part(base) {
    background: linear-gradient(119.51deg, #3e5dff 3.37%, #6404c5 115.71%);
    ${BaseStyledBadge}
  }
`

const ConcentratedLiquidityBadge: React.FC = () => {
  const { t } = useTranslation()

  return (
    <SlTooltip
      content={t(
        'It is concentrated liquidity pool. Resulted liquidity for trading in this pool is several times higher than it is shown in numbers. As a result it generates more trading volume and more trading fee rewards for liquidity providers.',
      )}
      hoist
    >
      <StyledSlBadge className="pointer-events-auto" pill>
        CL
        <HelpIcon height="10px" width="10px" ml="2px" />
      </StyledSlBadge>
    </SlTooltip>
  )
}

export default ConcentratedLiquidityBadge
